export default "__VITE_ASSET__BTr4_oLN__"